module.exports = __webpack_public_path__ + "img/ARB.5f10e57a.png";